<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <div class="text-xs-right">
          <!-- <v-btn
            flat
            :color="$store.state.global.pages.contractor.color"
            @click="openRequest"
          >Create Request</v-btn>-->

          <v-btn flat color="grey" @click="toggleView()">
            <v-icon left v-if="listView">list</v-icon>
            <v-icon left v-else>view_module</v-icon>View
          </v-btn>
        </div>
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 lg3>
          <div class="flex-container-space-between">
            <v-autocomplete
              :prepend-icon="$store.state.global.pages.contractor.icon"
              :color="$store.state.global.pages.contractor.color"
              label="Sub-contractor"
              :items="contractors"
              v-model="contractor"
              item-text="name"
              :clearable="true"
              :loading="loadingContractors"
              item-value="id"
            ></v-autocomplete>
            <div class="ml-3" v-if="!!contractor">
              <v-switch
                :color="$store.state.global.pages.contractor.color"
                label="Details"
                v-model="showDetails"
              ></v-switch>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Sort by..."
            :items="sortFactors"
            v-model="sortBy"
            prepend-icon="sort"
            :disabled="listView"
            dense
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Type"
            :items="['Active', 'Inactive', 'Request']"
            v-model="selectedRecordType"
          ></v-select>

          <!-- <v-checkbox
            :color="$store.state.global.pages.driver.color"
            label="Show Only Inactive"
            v-model="showInactive"
          ></v-checkbox>-->
        </v-flex>

        <!--CONTROL INFO DISPLAY -->
        <control-info-display :data="contractorObj" route="contractor" v-model="showDetails"></control-info-display>
      </layout-no-padding>

      <v-dialog v-model="addDriverDialog" max-width="500px" @keydown.esc="addDriverDialog = false">
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-driver" slot="activator">
          <v-icon dark>{{ isRequest ? 'post_add' : 'add' }}</v-icon>
        </v-btn>
        <!-- ADD DRIVER COMPONENT-->
        <add-driver @close="addDriverDialog = false" :isRequest="isRequest"></add-driver>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DriverService from '@/services/requests/driverService'
import ContractorService from '@/services/requests/contractorService'

// MIXINS
import DriverValidation from '@/services/validation/driverValidation'
import RouteProps from '@/services/mixins/routeProps'
import getDrivers from '@/services/mixins/getMasterFiles/getDrivers'
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'

// COMPONENTS
import AddDriver from '@/components/drivers/addDriver'
import ControlInfoDisplay from '@/components/ui/controlInfoDisplay'

export default {
  mixins: [
    DriverValidation,
    RouteProps,
    getDrivers,
    getContractors,
    getProjects,
  ],
  components: {
    AddDriver,
    ControlInfoDisplay,
  },
  data() {
    return {
      includeInactive: true,
      addDriverDialog: false,
      sortFactors: [
        {
          value: 'id',
          text: 'ID',
        },
        {
          value: 'name',
          text: 'Name',
        },
        {
          value: 'contractor.name',
          text: 'Contractor',
        },
        {
          value: 'updatedAt',
          text: 'Updated At',
        },
      ],
    }
  },
  methods: {
    toggleView() {
      this.listView = !this.listView
    },
  },
  computed: {
    contractorObj() {
      if (!!this.contractor) {
        return this.getObjByPrimaryId(this.contractor, this.contractors)
      } else {
        return null
      }
    },
    isRequest() {
      return this.$store.state.user.userAuthClass.name !== 'Administrator'
    },
    sortBy: Store.getSet({ store: 'drivers', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'drivers', prop: 'filterBy' }),
    listView: Store.getSet({ store: 'drivers', prop: 'listView' }),
    contractor: Store.getSet({ store: 'drivers', prop: 'contractor' }),
    showDetails: Store.getSet({ store: 'drivers', prop: 'showDetails' }),
    showInactive: Store.getSet({ store: 'drivers', prop: 'showInactive' }),
    selectedRecordType: Store.getSet({
      store: 'drivers',
      prop: 'selectedRecordType',
    }),
  },
  watch: {
    contractorObj(val) {
      if (!!val) {
        this.showDetails = true
      } else {
        this.showDetails = false
      }
    },
  },
}
</script>

<style scoped>
.overlap-fab-driver {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}

.card-divider {
  margin: 15px 0px;
}
</style>


<!-- <v-card>       
  <v-card-title class="flex-container-space-between">
    <div>   
      <h2 class="headline">Drivers</h2>
    </div>
    <div>
      <v-btn flat color="grey" @click="toggleView()">
        <v-icon left v-if="listView">list</v-icon>
        <v-icon left v-else>view_module</v-icon>
        View
      </v-btn>
    </div>
    <div class="card-divider grey lighten-2"></div>
  </v-card-title>  

  <v-dialog v-model="addDriverDialog" max-width="500px">
    <v-btn fab dark color="indigo" class="overlap-fab" slot="activator">
      <v-icon dark>add</v-icon>
    </v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Add Driver</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field label="Name" v-model="name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="Contact Email" v-model="contactEmail"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  label="Contractor"
                  :items="contractors"
                  v-model="contractor"
                  item-text="name"
                  item-value="id">
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="addDriverDialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="submitAddDriver()">Add</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>         
</v-card> -->